<template>
	<div class="rescue">
		<a-row class="home-head">
	      <a-col :span="8">
	        <p>求救区</p>
	      </a-col>
	      <a-col :span="7">
	        <p>施救区</p>
	      </a-col>
	      <a-col :span="9">
	        <p>派遣区  <a @click="front" style="float:right;margin-right: 13px;line-height: 60px; font-size: 22px;color:#fff;">返回</a></p> 
	      </a-col>
	   </a-row>
	<a-row class="rescue-body">
      <a-col style="width:33%;float: left">
      	<a-collapse id="home-content" style="max-height:92vh;overflow: auto;" accordion :defaultActiveKey="rescueSN">
        	<ul class="home-group">
            <li v-for="(group,index) in groups" :class="{selected:groupIndex == index}" @click="getTeamByGroup(group,index)">{{group}}</li>  
          </ul> 
          <a-collapse-panel v-for="(item,index) in TeamMemberListCall" v-show="item.GroupName==group && !item.isOnLine && item.isInit" :key="item.SN"> 
            <template slot="header" >
              <div class="team-info" @click="collapseChange(item.SN,item.RelativelyHigh)">  
              	<!-- 定位器姿势图片 -->  
                <span> 
                  {{item.Locations}}
                  <img src="../assets/images/card_notonline.png" v-if="item.isOnLine"/>  
                  <img src="../assets/images/card_stand.gif" v-else-if="item.Location==null"/> 
                  <img src="../assets/images/card_stand.gif" v-else-if="item.Location.Posture==42"/> 
                  <img src="../assets/images/card_walk.gif" v-else-if="item.Location.Posture==43"/> 
                  <img src="../assets/images/card_run.gif" v-else-if="item.Location.Posture==44"/>
                  <img src="../assets/images/card_cramb.gif" v-else-if="item.Location.Posture==45"/>
                  <img src="../assets/images/card_strair_up.gif" v-else-if="item.Location.Posture==46"/>
                  <img src="../assets/images/card_strair_down.gif" v-else-if="item.Location.Posture==47"/>  
                  <img src="../assets/images/card_lie_side.gif" v-else-if="item.Location.Posture==49"/>
                  <img src="../assets/images/card_lie_down.gif" v-else-if="item.Location.Posture==50"/>
                  <img src="../assets/images/card_lie_up.gif" v-else-if="item.Location.Posture==51"/> 
                  <img src="../assets/images/card_lie_side.gif" v-else-if="item.Location.Posture==52"/>
                  <img src="../assets/images/card_stand.gif" v-else/> 
                </span>
                <!-- 呼救器状态图标 -->
                <span>
                  <img src="../assets/images/icon_alarm_notonline_64.png" v-if="item.isOnLine"/>
                  <img src="../assets/images/icon_alarm_normal_64.png" v-else-if="item.AlarmStatus==0"/>
                  <img src="../assets/images/home_icon_recco_manualalert.png" v-else-if="item.AlarmStatus==3"/>
                  <img src="../assets/images/home_icon_recco_alarmstrong.png" v-else-if="item.AlarmStatus==4"/>
                  <img src="../assets/images/home_icon_recco_strongalert.png" v-else-if="item.AlarmStatus==6"/>
                  <img src="../assets/images/icon_alarm_normal_64.png" v-else/>
                  <br>
                  {{item.Name}} 
                </span>     
              	<span style="margin:0;width:27%">
	              	<button @click.stop="relieveRescue(item.SN,item.Name)" >解除施救</button>
	              </span>   
              	<div style="clear: both;"></div>
              </div>
            </template> 
            

            <!-- 呼救器信息 -->
            <div :class="{'off-line':item.isOnLine}">
              <p>
                <img src="../assets/images/home_icon_ecco_notonline.png" v-if="item.isOnLine"/>
                <img src="../assets/images/home_icon_ecco.png" v-else/>互救器
              </p>
              <ul>
                <li>
                  <template v-if="item.isOnLine">
                    <img src="../assets/images/home_icon_battery_full-notonline.png" /><br/> 
                    <font>设备电量</font> 
                  </template>
                  <template v-else-if="item.ICUEle>75">
                    <img src="../assets/images/home_icon_battery_full.png" /><br/>
                    <font class="red" v-if="item.ICUEle<=ConfigList.EquipmentBattery">设备电量</font>
                    <font v-else>设备电量</font> 
                  </template>
                  <template v-else-if="item.ICUEle>50">
                    <img src="../assets/images/home_icon_battery_three.png" /><br/>
                    <font class="red" v-if="item.ICUEle<=ConfigList.EquipmentBattery">设备电量</font>
                    <font v-else>设备电量</font> 
                  </template>
                  <template v-else-if="item.ICUEle>25">
                    <img src="../assets/images/home_icon_battery_two.png" /><br/>
                    <font class="red" v-if="item.ICUEle<=ConfigList.EquipmentBattery">设备电量</font>
                    <font v-else>设备电量</font> 
                  </template>
                  <template v-else>
                    <img src="../assets/images/home_icon_battery_alert.png" /><br/> 
                    <font class="red" v-if="item.ICUEle<=ConfigList.EquipmentBattery">设备电量</font>
                    <font v-else>设备电量</font> 
                  </template>
                </li>
                <li> 
                  <template v-if="item.isOnLine">
                    <img src="../assets/images/home_icon_recco_notonline.png"/><br/>
                    <font>离线</font>
                  </template>
                  <template v-else-if="item.AlarmStatus==3">
                    <img src="../assets/images/home_icon_recco_manualalert.png"/><br/>
                    <font>手动报警</font>
                  </template>
                  <template v-else-if="item.AlarmStatus==4">
                    <img src="../assets/images/home_icon_recco_alarmstrong.png"/><br/>
                    <font>预报警</font>
                  </template>
                  <template v-else-if="item.AlarmStatus==6">
                    <img src="../assets/images/home_icon_recco_strongalert.png"/><br/>
                    <font>强报警</font>
                  </template>
                  <template v-else>
                    <img src="../assets/images/icon_alarm_normal_64.png"/><br/>
                    <font>正常</font>
                  </template>
                </li>

                <li class="padtop" :class="{red:!item.isOnLine && item.Temperature > ConfigList.AmbienTemperature}"> 
                  {{item.Temperature==null ? '-' : item.Temperature}} °C<br/>
                  环境温度
                </li>

                <li class="padtop" :class="{red:!item.isOnLine && item.WorkTime > ConfigList.TimeOfDeparture}">  
                  <template v-if="item.WorkTime==null">
                    00 : 00
                  </template>
                  <template v-else>
                    {{Math.floor(item.WorkTime/60)<10?'0'+Math.floor(item.WorkTime/60):Math.floor(item.WorkTime/60)}}:
                    {{item.WorkTime%60<10?'0'+item.WorkTime%60:item.WorkTime%60}}
                  </template> 
                  <br/>
                  出发时长
                </li>
                <li class="padtop">
                  {{item.RelativelyHigh == null ? item.Altitude : item.RelativelyHigh}} 米<br/>
                  {{item.RelativelyHigh == null ?'海拔高度':'相对高度'}}
                </li>
              </ul>
            </div> 
 
            <div> 
              <!-- 空呼气瓶信息 -->
              <div class="left" :class="{'off-line':item.isOnLine || !item.GASIsOnLine}">
                <p>
                  <img src="../assets/images/home_icon_oxygen_notonline.png" v-if="item.isOnLine || !item.GASIsOnLine"/>
                  <img src="../assets/images/home_icon_oxygen.png" v-else/>空呼气瓶
                </p>
                <ul>
                  <li>
                    <template v-if="item.isOnLine || !item.GASIsOnLine">
                      <img src="../assets/images/home_icon_battery_full-notonline.png" /><br/> 
                      <font>设备电量</font>  
                    </template>
                    <template v-else-if="item.GASEle>75">
                      <img src="../assets/images/home_icon_battery_full.png" /><br/>
                      <font class="red" v-if="item.GASEle<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font>  
                    </template>
                    <template v-else-if="item.GASEle>50">
                      <img src="../assets/images/home_icon_battery_three.png" /><br/>
                      <font class="red" v-if="item.GASEle<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font>  
                    </template>
                    <template v-else-if="item.GASEle>25">
                      <img src="../assets/images/home_icon_battery_two.png" /><br/>
                      <font class="red" v-if="item.GASEle<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font>  
                    </template>
                    <template v-else>
                      <img src="../assets/images/home_icon_battery_alert.png" /><br/>
                      <font class="red" v-if="item.GASEle<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font>  
                    </template>
                  </li> 
                  <li class="padtop" :class="{red:!item.isOnLine && item.GASIsOnLine && item.GASPressure <= ConfigList.CallPressure}"> 
                    {{item.GASPressure==null ? '-' : item.GASPressure}} MPa<br/>
                    空呼余量
                  </li> 
                  <li class="padtop" :class="{red:!item.isOnLine && item.GASIsOnLine && item.GASRemainingTime <= ConfigList.CallRemainingTime}"> 
                    {{item.GASRemainingTime==null ? '-' : item.GASRemainingTime}} min<br/>
                    剩余时长
                  </li> 
                </ul>
              </div> 

              <!-- 耳机手环信息 -->
              <div class="right" style="border-bottom: 0;" :class="{'off-line':item.isOnLine || !item.Device || item.Device == 0}">
                <p style="padding-left: 6px">
                  <img src="../assets/images/home_icon_bracelet_notonline.png" v-if="item.isOnLine || !item.Device || item.Device == 0"/>
                  <img src="../assets/images/home_icon_bracelet.png" v-else/>耳机/手环  
                </p>
                <ul>
                  <li>
                    <template v-if="item.isOnLine || !item.Device || item.Device == 0">
                      <img src="../assets/images/home_icon_battery_full-notonline.png" /><br/> 
                      <font>设备电量</font> 
                    </template>
                    <template v-else-if="item.DeviceEle>75">
                      <img src="../assets/images/home_icon_battery_full.png" /><br/>
                      <font class="red" v-if="item.DeviceEle <= ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font> 
                    </template>
                    <template v-else-if="item.DeviceEle>50">
                      <img src="../assets/images/home_icon_battery_three.png" /><br/>
                      <font class="red" v-if="item.DeviceEle<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font> 
                    </template>
                    <template v-else-if="item.DeviceEle>25">
                      <img src="../assets/images/home_icon_battery_two.png" /><br/>
                      <font class="red" v-if="item.DeviceEle<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font> 
                    </template>
                    <template v-else>
                      <img src="../assets/images/home_icon_battery_alert.png" /><br/>
                      <font class="red" v-if="item.DeviceEle<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font> 
                    </template>
                  </li>  
                  <li class="padtop" :class="{red: !item.isOnLine && item.Device && item.Device == 1 && (item.DeviceHeartRate>ConfigList.TeamHeartRateMax || item.DeviceHeartRate<ConfigList.TeamHeartRateMin)}"> 
                    {{item.DeviceHeartRate==null ? 0: item.DeviceHeartRate}} bpm<br/>
                    队员心率
                  </li> 
                </ul>
              </div> 
            </div>  
            <div>  
              <!-- 定位器信息 --> 
              <div class="left" :class="{'off-line':item.isOnLine || item.Location.isOnLine || JSON.stringify(item.Location)=='{}'}">
                <p>
                  <img src="../assets/images/home_icon_locator_notonline.png" v-if="item.Location.isOnLine || JSON.stringify(item.Location)=='{}'"/>
                  <img src="../assets/images/home_icon_locator.png" v-else/>定位器 
                </p>
                <ul>
                  <li>  
                    <template v-if="item.Location.isOnLine || JSON.stringify(item.Location)=='{}'">
                      <img src="../assets/images/home_icon_battery_full-notonline.png" /><br/> 
                      <font>设备电量</font> 
                    </template>
                    <template v-else-if="item.Location.TrackElec>75">
                      <img src="../assets/images/home_icon_battery_full.png" /><br/>
                      <font class="red" v-if="item.Location.TrackElec<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font> 
                    </template>
                    <template v-else-if="item.Location.TrackElec>50">
                      <img src="../assets/images/home_icon_battery_three.png" /><br/>
                      <font class="red" v-if="item.Location.TrackElec<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font> 
                    </template> 
                    <template v-else-if="item.Location.TrackElec>25">
                      <img src="../assets/images/home_icon_battery_two.png" /><br/>
                      <font class="red" v-if="item.Location.TrackElec<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font> 
                    </template>
                    <template v-else>
                      <img src="../assets/images/home_icon_battery_alert.png" /><br/> 
                      <font class="red" v-if="item.Location.TrackElec<=ConfigList.EquipmentBattery">设备电量</font>
                      <font v-else>设备电量</font> 
                    </template>
                  </li> 
                  <li class="padtop">  
                    {{(item.FloorNumber==0 || item.FloorNumber==null || item.FloorNumber==undefined)?'-':item.FloorNumber}}<br/>
                    当前层
                  </li>
                  <li class="padtop"> 
                    {{'-'}} 米<br/>
                    总路程
                  </li> 
                </ul>
              </div> 

              <!-- 耳机手环信息 -->
              <div class="right" :class="{'off-line':item.isOnLine || !item.Device || item.Device != 2}"> 
                <ul> 
                  <li class="padtop" 
                    :class="{'red': !item.isOnLine && item.Device && item.Device == 2 && item.DeviceTemperature < ConfigList.BodySurfaceTemperatureMin}"> 
                    {{item.DeviceTemperature==null ? '-' : item.DeviceTemperature}} °C<br/>
                    队员体温
                  </li>    
                  <li class="padtop" 
                    :class="{'red': !item.isOnLine && item.Device && item.Device == 2 && item.DeviceBloodOxygen < ConfigList.BloodOxygenMin}"> 
                    {{item.DeviceBloodOxygen==null?'-':item.DeviceBloodOxygen}} %<br/>
                    血氧浓度
                  </li> 
                </ul>
              </div> 
            </div>


          </a-collapse-panel>
        </a-collapse>
      	
      	
      </a-col>
      <a-col style="width:30%;float: left">
      	<div class="rescue-center">   
      		<div class="rescue-center-data" v-for="item in rescueList" v-show="TeamMemberListCall.length && item.AlarmStatus != 6 && item.AlarmStatus != 3">
      			<img src="../assets/images/team_img_people.png" alt="" class="kh-img"/>
      			<div class="rescue-center-data-left">  
              <p> 
                <img src="../assets/images/icon_search_ecco.png" alt="" />
                {{item.Rescuing==null?'-':item.Rescuing.Signal}}
                <!-- {{item.Rescuing==null?'-':item.Rescuing.Signal}} -->
              </p>
	      			<p>
	      				<img src="../assets/images/icon_search_height.png" alt="" /> 
	      				{{item.RelativelyHigh==undefined || item.RelativelyHigh==null || relativeHeight==undefined ? '-' : (relativeHeight-item.RelativelyHigh).toFixed(1)}}M
	      			</p> 
      			</div>
      			<span>
      				{{item.GASPressure==null?'-':item.GASPressure}}MPa<br/>
      				{{item.GASRemainingTime==null?'-':item.GASRemainingTime}}min
      			</span>
      			<h4 v-if="item.AlarmStatus==4" style="color:#FFBB07">{{item.GroupName +' '+item.Name}}</h4>
            <h4 v-else>{{item.GroupName +' '+item.Name}}</h4>
      			<button @click="closeRescue($event,item.SN)"><font>×</font></button> 

            <img class="bottle" src="" alt="" v-if=" !item.GASPressure || item.GASPressure == 0"/>  
            <img class="bottle" src="" alt="" v-else :style="{backgroundPosition:getPosition(item.GASPressure)}"/>      
      		</div>  
      		<div class="rescue-null" v-show="rescueList.length==0">
      			<img src="../assets/images/team_img_workzone_default.png" alt="" />
      			<p>暂无施救人员<br>请从派遣区拖动到此</p>
      		</div>
      		<input type="hidden" class="rescue-null" />
      	</div>
      </a-col>
      
      <a-col style="width:37%;float: left">
      	<div class="rescue-right">
	      	<h4>最佳施救人员</h4>
	      	<div class="rescue-right-hot clearfloat" style="min-height: 400px;">   


             


	      		<div class="rescue-right-list" @mousedown="down" @touchstart="down"  v-for="item in freeTeamList.best" v-show="TeamMemberListCall.length && item.AlarmStatus != 6 && item.AlarmStatus != 3 && item.isOnLine != true">
	      			<img src="../assets/images/team_img_people.png" alt="" style="height:135px"/> 
              <h5 v-if="item.AlarmStatus==4" style="color:#FFBB07">{{item.GroupName +' '+item.Name}}</h5>
	      			<h5 v-else>{{item.GroupName +' '+item.Name}}</h5>
	      			<p>
	      				<img src="../assets/images/home_icon_ecco.png" alt="" />
                  {{waitRescues(item.WaitRescues)}} 
	      				<br/>
	      				<img src="../assets/images/icon_search_height_offline.png" alt="" /> 
	      				{{item.RelativelyHigh==undefined || item.RelativelyHigh==null || relativeHeight==undefined ? '-' : (relativeHeight-item.RelativelyHigh).toFixed(1)}}M
	      			</p>
	      			<input type="hidden" v-model="item.SN"/>
	      			<span>
	      				{{item.GASPressure==null?'-':item.GASPressure}}MPa<br/>
                {{item.GASRemainingTime==null?'-':item.GASRemainingTime}}min
	      			</span>   
              <img class="bottle" src="" alt="" v-if="!item.GASPressure || item.GASPressure == 0"/>  
              <img class="bottle" src="" alt="" v-else :style="{backgroundPosition:getPosition(item.GASPressure)}"/>    
	      		</div>  
	      	</div>
	      	<h4>其他人员</h4> 
	      	<div class="rescue-right-hot clearfloat"> 
            <div class="rescue-right-list" @mousedown="down" @touchstart="down"  v-for="item in freeTeamList.other" v-show="TeamMemberListCall.length && item.AlarmStatus != 6 && item.AlarmStatus != 4 && item.isOnLine != true">
              <img src="../assets/images/team_img_people.png" alt="" style="height:135px"/> 
              <h5 v-if="item.AlarmStatus==4" style="color:#FFBB07">{{item.GroupName +' '+item.Name}}</h5>
              <h5 v-else>{{item.GroupName +' '+item.Name}}</h5>
              <p>
                <img src="../assets/images/home_icon_ecco.png" alt="" />
                  {{waitRescues(item.WaitRescues)}} 
                <br/>
                <img src="../assets/images/icon_search_height_offline.png" alt="" /> 
                {{item.RelativelyHigh==undefined || item.RelativelyHigh==null || relativeHeight==undefined ? '-' : (relativeHeight-item.RelativelyHigh).toFixed(1)}}M
              </p>
              <input type="hidden" v-model="item.SN"/>
              <span>
                {{item.GASPressure==null?'-':item.GASPressure}}MPa<br/>
                {{item.GASRemainingTime==null?'-':item.GASRemainingTime}}min
              </span> 
              <img class="bottle" src="" alt="" v-if="!item.GASPressure || item.GASPressure == 0"/>  
              <img class="bottle" src="" alt="" v-else :style="{backgroundPosition:getPosition(item.GASPressure)}"/>    
            </div>  
          </div>   
      	</div>
      </a-col>
      
    </a-row>
	    
    <retreat :show="isRetreat" :msg="msg" @ok="okRetreat" @cancal="cancalRetreat"></retreat>	
	</div>
</template>

<script>
	import { Component, Vue } from "vue-property-decorator";
	import { Button } from "ant-design-vue";   
	import RescueService from "../api/RescueService"
	import Retreat from "../components/retreat"
	export default {
		inject: ["reload"],
		data() {
		    return {
		      message: "Hello World!",
		      msg: "Welcome to Your Vue.js + TypeScript App",
		      groupName:[],//所有初始化过后数据的组别
		      group:'',//选中数据的组别
          groups:[],
		      index:0,
		      groupIndex:0,//选中数据组别对应的索引
		      monitBox:false,
		      left:0,
		      top:0,
		      X:0,
		      Y:0,
		      height:'',
		      elen:null,
          relativeHeight:0,
		      rescueSN:'',
		      crySN:'',
		      rescueList:[],
		      isRetreat:false,
		      peopleSN:'',
		      msg:'',
		      equipment:'',
		      freeTeamList:[],
          setInterval:null,
          setIntervalRescue:null
		    }
		},
		created(){    

      this.groups = this.$store.state.TeamMemberGroups
 
      //this.relativeHeight = this.$route.query.relativeHeight
			this.rescueSN = this.$route.query.sn
			this.group = this.$route.query.group
			this.groupIndex = this.groups.indexOf(this.group)
      for (var i = 0; i < this.TeamMemberLists.length; i++) {
        if(this.TeamMemberLists[i].SN == this.rescueSN){  
          this.relativeHeight = this.TeamMemberLists[i].RelativelyHigh 
        }
      }


			this.getRescueBySN()
			this.getTeamByFree() 
      this.setIntervalRescue = setInterval(()=>{
        this.getRescueBySN() 
        this.getTeamByFree() 
      },3000) 


			if(/Android|webOS|iPhone|iPod|iPad|BlackBerry/i.test(navigator.userAgent)){
			   	this.equipment='move'
			} else {
			    this.equipment='pc'
			} 
      //this.equipment='pc'
      
      this.intervalCheckOnline()
      this.setInterval = setInterval(()=>{
        this.intervalCheckOnline()
      },60000) 
		}, 
		mounted(){
			var height = document.body.offsetHeight - document.getElementsByClassName('home-head')[0].offsetHeight
			document.getElementsByClassName('rescue-center')[0].style.height = height + 'px'
			document.getElementsByClassName('rescue-right')[0].style.height = height + 'px' 
			document.getElementsByClassName('rescue-null')[0].style.marginTop = (height-document.getElementsByClassName('rescue-null')[0].offsetHeight)/2 + 'px' 
			let elen= document.getElementsByClassName('rescue-right-hot')[0].getElementsByTagName('div') 
			for(let i=0;i<elen.length;i++){
				elen[i].style.height = elen[0].offsetWidth+'px'
				this.height = elen[0].offsetWidth+'px'
			} 
    }, 
    beforeDestroy(){
      clearInterval(this.setIntervalRescue)
      clearInterval(this.setInterval)
    }, 
		methods:{
      intervalCheckOnline(){   

        for (var i = 0; i < this.TeamMemberLists.length; i++) {   
          if(this.TeamMemberLists[i].UDTime ==undefined || parseInt(new Date(this.getTimes()) - new Date(this.TeamMemberLists[i].UDTime))/1000 > 65){  
            Vue.set(this.TeamMemberLists[i],'isOnLine',true)  
     
          }else{  
            Vue.set(this.TeamMemberLists[i],'isOnLine',false)
          }  

          if(this.TeamMemberLists[i].Location == undefined || JSON.stringify(this.TeamMemberLists[i].Location)=='{}'){  
            Vue.set(this.TeamMemberLists[i],'Location',{}) 
          }else{
            if(parseInt(new Date(this.getTimes()) - new Date(this.TeamMemberLists[i].Location.UDTime))/1000 > 65){  
              Vue.set(this.TeamMemberLists[i].Location,'isOnLine',true)  
            }else{   
              Vue.set(this.TeamMemberLists[i].Location,'isOnLine',false)
            }
          } 
        } 
      },
      front(){
        this.$router.go(-1)
      },
      getTimes(data,type){
        var _data = data; 
        //如果是13位正常，如果是10位则需要转化为毫秒
        if(data ==undefined){
          const time = new Date();   
          const Y = time.getFullYear()
          const Mon = time.getMonth() + 1
          const Day = time.getDate()
          const H = time.getHours()
          const Min = time.getMinutes()
          const S = time.getSeconds()
          return `${Y}/${Mon}/${Day} ${H}:${Min}:${S}`
        }else{
          if (String(data).length == 13) {
            _data = data
          } else {
            _data = data*1000
          } 
          const time = new Date(_data)    
          const Y = time.getFullYear()
          const Mon = time.getMonth() + 1
          const Day = time.getDate()
          const H = time.getHours()
          const Min = time.getMinutes()
          const S = time.getSeconds() 
          if(type=="Y"){
            return `${Y}-${Mon}-${Day}`
          }else if(type=="H"){
            return `${H}:${Min}:${S}`
          }else{
            return `${Y}/${Mon}/${Day} ${H}:${Min}:${S}`
          }
        } 
      },
      collapseChange(sn,relativeHeight){  
        this.relativeHeight = relativeHeight
        this.rescueSN = sn 
        this.getRescueBySN() 
        this.getTeamByFree() 
        
      },
			getTeamByFree(){
				RescueService.getTeamByFree().then(
	        		res => { 
				        if (res.status == 200) {
				          	if (res.data.status == 1000) {   
                      if(res.data.data){
                        let tempData = res.data.data
                        let best = tempData.best
                        let other = tempData.other
                        /*for (let i = 0; i < best.length; i++) {
                          if(parseInt(new Date(this.getTimes()) - new Date(best[i].UDTime))/1000 > 60){ 
                            Vue.set(best[i],'isOnLine',true) 
                          }else{ 
                            Vue.set(best[i],'isOnLine',false)
                          }
                        }
                        for (let i = 0; i < other.length; i++) {
                          if(parseInt(new Date(this.getTimes()) - new Date(other[i].UDTime))/1000 > 60){
                            Vue.set(other[i],'isOnLine',true) 
                          }else{
                            Vue.set(other[i],'isOnLine',false)
                          }
                        }*/
 
                        for (var i = 0; i < best.length; i++) {   
                          if(best[i].UDTime ==undefined || parseInt(new Date(this.getTimes()) - new Date(best[i].UDTime))/1000 > 65){  
                            Vue.set(best[i],'isOnLine',true)  
                          }else{  
                            Vue.set(best[i],'isOnLine',false)
                          }  
                        }  

                        for (var i = 0; i < other.length; i++) {   
                          if(other[i].UDTime ==undefined || parseInt(new Date(this.getTimes()) - new Date(other[i].UDTime))/1000 > 65){  
                            Vue.set(other[i],'isOnLine',true)  
                          }else{  
                            Vue.set(other[i],'isOnLine',false)
                          }  
                        } 


                        Vue.set(tempData,'best',best)
                        Vue.set(tempData,'other',other)





                        this.freeTeamList = tempData  
                      }
                      
				          	} else if (res.status == 200){ 
				          		this.rescueList=[]  
				          	}
				        } else { 
				        	this.$message.warning(res.message)
				        }
			      	},
			      	err => {
			        	this.$message.warning(err.message)
			      	}
	        	)
			},
			getRescueBySN(){
				RescueService.getRescueBySN({rsn:this.rescueSN}).then(
	        		res => { 
				        if (res.status == 200) {
				          	if (res.data.status == 1000) {  
                      if(res.data.data != null){
                        let tempData =  res.data.data 
                        /*for (var i = 0; i < tempData.length; i++) { 
                          if(parseInt(new Date(this.getTimes()) - new Date(tempData[i].UDTime))/1000 > 60){
                            Vue.set(tempData[i],'isOnLine',true) 
                          }else{
                            Vue.set(tempData[i],'isOnLine',false)
                          }
                        }  */
                        this.rescueList = tempData
                      }else{
                        this.rescueList=[]
                      }  
				          	} else if (res.status == 200){ 
				          		this.rescueList=[] 
				          	}
				        } else { 
				        	this.$message.warning(res.message)
				        }
			      	},
			      	err => {
			        	this.$message.warning(err.message)
			      	}
	        	)
			},
			//解除施救
			relieveRescue(SN,name){
				this.crySN=SN
				this.msg ='是否解除对<font style="color:#40DC23;margin:0 5px;">'+name+'</font>的营救？'
				this.isRetreat=true 
			},
			closeRescue(e,sn){
				this.msg='是否取消施救'
				this.peopleSN=sn
				this.isRetreat=true  
			},
			okRetreat(){
        this.isRetreat=false
				if(this.msg == '是否取消施救'){  
					RescueService.MemberRescue({rescueType:2,sn:this.peopleSN}).then(
		        		res => { 
					        if (res.status == 200) {
					          	if (res.data.status == 1000) {   
  							          
                        this.$message.warning('取消施救命令已发送')
                        setTimeout(()=>{
                          this.getRescueBySN()
                          this.getTeamByFree() 
                        },500) 
					          	} else if (res.status == 200){
					          		this.$message.warning(res.data.msg)
					          	}
					        } else {
					        	this.$message.warning(res.message)
					        }
				      	},
				      	err => {
				        	this.$message.warning(err.message)
				      	}
		        	)
				}else{ 
					RescueService.removeRescue({rsn:this.crySN}).then(
		        		res => { 
					        if (res.status == 200) { 
					          	if (res.data.status == 1000) {    
                        this.$message.warning('解除施救命令已发送')
							          setTimeout(()=>{
                          this.getRescueBySN()
                          this.getTeamByFree() 
                        },500) 
					          	} else{
					          		this.$message.warning('没有正在施救的队员')
                        this.isRetreat=false
					          	}
					        } else {
					        	this.$message.warning(res.message)
					        }
				      	},
				      	err => {
				        	this.$message.warning(err.message)
				      	}
		        	)
				}
			},
			cancalRetreat(){
				this.isRetreat=false
			},
			move(e){  
				if(e.touches){
					this.elen.style.left = e.touches[0].clientX-(this.X-this.left) + 'px'
					this.elen.style.top = e.touches[0].clientY-(this.Y-this.top) + 'px' 
				}else{
					this.elen.style.left = e.clientX-(this.X-this.left) + 'px'
					this.elen.style.top = e.clientY-(this.Y-this.top) + 'px'
				}
				
				
				let sjLeft = document.getElementsByClassName('rescue-center')[0].getBoundingClientRect().left
				if(this.elen.getBoundingClientRect().left<=sjLeft){
		        	this.elen.style.left = sjLeft + 'px'
		        }
				if(this.elen.getBoundingClientRect().top<=60){
		        	this.elen.style.top = '60px'
		      	}  
				if(this.elen.getBoundingClientRect().right>=document.body.offsetWidth){
		        	this.elen.style.left = document.body.offsetWidth-this.elen.offsetWidth + 'px'
		      	}  
				if(this.elen.getBoundingClientRect().bottom>=document.body.offsetHeight){  
		        	this.elen.style.top=document.body.offsetHeight-this.elen.offsetHeight +'px'
		       	}  
			},
			end(e){ 
				if(e.touches){
					document.removeEventListener('touchmove', this.move)
		        	document.removeEventListener('touchend', this.end) 
				}else{
					this.elen.removeEventListener('mousemove', this.move)
		        	this.elen.removeEventListener('mouseup', this.end) 
				}
				
		        let pqLeft =  document.getElementsByClassName('rescue-right')[0].getBoundingClientRect().left
		        if(this.elen.getBoundingClientRect().left>=pqLeft-80){
		        	document.getElementsByClassName('rescue-right-hot')[0].removeChild(this.elen)
		        }else{  
		        	document.getElementsByClassName('rescue-right-hot')[0].removeChild(this.elen)
		        	let sn = this.elen.getElementsByTagName('input')[0].value  
              if(this.rescueSN == sn){
                this.$message.warning('请在求救区选择一个需要求救的队员')
              }else{
                RescueService.MemberRescue({rescueType:1,RescueSN:this.rescueSN,sn:sn}).then(
                  res => { 
                    if (res.status == 200) {
                        if (res.data.status == 1000) {   
                          this.$message.warning('施救命令已发送')
                          this.getRescueBySN()
                          this.getTeamByFree()
                        } else if (res.status == 200){
                          this.$message.warning(res.data.msg)
                        }
                    } else {
                      this.$message.warning(res.message)
                    }
                  },
                  err => {
                    this.$message.warning(err.message)
                  }
                )
              }
		        	
		        }
			},
			down(e){   
        e.preventDefault && e.preventDefault() 
				let newNode = e.currentTarget.cloneNode(true) 
				this.elen = e.currentTarget
				this.left = this.elen.getBoundingClientRect().left
				this.top = this.elen.getBoundingClientRect().top
				this.elen = newNode 
				if(e.touches){
					this.X = e.touches[0].clientX
					this.Y = e.touches[0].clientY 
					this.elen.style.left = e.touches[0].clientX-(this.X-this.left) + 'px'
					this.elen.style.top = e.touches[0].clientY-(this.Y-this.top) + 'px'
				}else{
					this.X = e.clientX
					this.Y = e.clientY 
					this.elen.style.left = e.clientX-(this.X-this.left) + 'px'
					this.elen.style.top = e.clientY-(this.Y-this.top) + 'px'
				}
				
				
				this.elen.style.width = e.currentTarget.offsetWidth +'px'
				this.elen.style.height = e.currentTarget.offsetHeight + 'px' 
				this.elen.style.position = 'fixed'
				this.elen.style.zIndex =3   
				document.getElementsByClassName('rescue-right-hot')[0].appendChild(this.elen) 
				if(e.touches){
					document.addEventListener('touchmove', this.move, false)
					document.addEventListener('touchend', this.end, false)  
				}else{
					this.elen.addEventListener('mousemove', this.move, false)
					this.elen.addEventListener('mouseup', this.end, false)  
				} 
			},
			 
	  	call(){
	  		this.monitBox=true
	  	},
	  	closeCall(){
	  		this.monitBox=false
	  	},
	  	getTeamByGroup(group,index){
	  		this.group =group
	  		this.groupIndex = index  
	  	},  
	  	timeDrop(t){
        if(t!=null){  
          return parseInt( new Date(this.getTime()) - new Date(this.getTime(t.UpdateTime)))/1000 >30
        }else{
          return true
        }
      },
		  getTime(data,type){
			  var _data = data;
			  //如果是13位正常，如果是10位则需要转化为毫秒
			  if(data ==undefined){
			  	const time = new Date();   
				  const Y = time.getFullYear()
				  const Mon = time.getMonth() + 1
				  const Day = time.getDate()
				  const H = time.getHours()
				  const Min = time.getMinutes()
				  const S = time.getSeconds()
				  return `${Y}/${Mon}/${Day} ${H}:${Min}:${S}`
			  }else{
			  	if (String(data).length == 13) {
				    _data = data
				  } else {
				    _data = data*1000
				  } 
				  const time = new Date(_data)    
				  const Y = time.getFullYear()
				  const Mon = time.getMonth() + 1
				  const Day = time.getDate()
				  const H = time.getHours()
				  const Min = time.getMinutes()
				  const S = time.getSeconds() 
				  if(type=="Y"){
				    return `${Y}-${Mon}-${Day}`
				  }else if(type=="H"){
				    return `${H}:${Min}:${S}`
				  }else{
				    return `${Y}/${Mon}/${Day} ${H}:${Min}:${S}`
				  }
			  } 
			}
		},
		computed: {
	    TeamMemberLists() {
	      return this.$store.state.TeamMemberLists;
	    },
      TeamMemberListCall(){  
        let teamMemberListCall=[]
        for (var i = 0; i < this.TeamMemberLists.length; i++) { 
          if(this.TeamMemberLists[i].AlarmStatus==3 || this.TeamMemberLists[i].AlarmStatus==6){
            teamMemberListCall.push(this.TeamMemberLists[i])
          } 
        }
        return teamMemberListCall
      },
      waitRescues(){
        return function(waitRescuesList){  
          let isSignal=true  
          if(waitRescuesList != null){
            for (var i = 0; i < waitRescuesList.length; i++) {
              if(this.rescueSN.substring(2) == waitRescuesList[i].SnNum){
                isSignal=false
                return waitRescuesList[i].Signal
                break
              }
            }
          }else{
            return '-'
          } 
          if(isSignal){
            return '-'
          }
        }
      }, 
      getPosition(){
        return function(mpaParams){   
          let mpa = Math.ceil(mpaParams) 
          mpa = mpa>30?30:mpa
          mpa = mpa<0?0:mpa 
          if(mpa<3){
            return -mpa*26-mpa+'px 0'
          }else if(mpa<11){
            return -mpa*26-mpa+'px 0'
          }else if(mpa<18){
            return -mpa*26-mpa-2+'px 0'
          }else if(mpa<25){
            return -mpa*26-mpa-4+'px 0'
          }else{
            return -mpa*26-mpa-6+'px 0'
          }  
        }
      },
	    ConfigList() {
	      return this.$store.state.Config
	    },
      ReccoTeamMemberList(){
        return this.$store.state.ReccoTeamMemberList
      },
      AllTeamMember(){
        return this.$store.state.AllTeamMember
      }
		},
		watch: {  
      ReccoTeamMemberList(to,from){  
        for (var i = 0; i < this.TeamMemberLists.length; i++) {
          if(this.TeamMemberLists[i].SN == this.rescueSN){
            this.relativeHeight = this.TeamMemberLists[i].RelativelyHigh
          }
        }  
        //this.getTeamByFree()
        //this.getRescueBySN()

        for (var i = 0; i < this.AllTeamMember.length; i++) { 
          if(this.AllTeamMember[i].SN == to.SN){  
            //获取组别信息   
            if(this.groups.indexOf(this.AllTeamMember[i].GroupName) =='-1'){ 
              this.groups.push(this.AllTeamMember[i].GroupName) 
            } 
            this.$store.commit('setTeamMemberGroups', this.groups)  
            Vue.set(this.TeamMemberLists[i],'GroupName',this.AllTeamMember[i].GroupName)
            //施救的sn号
            //Vue.set(this.TeamMemberLists[i],'Rescuing',to.Rescuing)   
            //待施救列表
            //Vue.set(this.TeamMemberLists[i],'WaitRescues',to.WaitRescues)   
 
          }  
        }

      }, 
		},
		components: {
		    Retreat 
		}
	} 
</script>

<style lang="less">
.rescue-center .bottle{
  width:27px!important;
  right:107px!important;
}

  .bottle{
    background: url(../assets/images/icon_bottle/icon_bottle.png) 0 0 no-repeat;
    height:80px;
    background-size:843px 80px;
    background-position: 0 0;
  }

	.rescue-null{
		text-align: center;
		font-size: 18px;
		color:#eee; 
		p{
			margin-top: 6px;
		} 
	}
	.rescue-right{
		background: #DDDCE2;
		padding:4px 5px;
    overflow: auto;
		h4{
			font-size: 18px;
		}
		.rescue-right-hot{ 
			div{
				cursor:move;
				background: #576371;
				margin:.5%;
				width:49%;
				height:200px;
				float:left;
				position: relative; 
				h5{
					padding:5px 10px;
					color:#40DC23;
					font-size: 18px;
				}
				>img{
					position: absolute;
				}
				img:first-child{
					width:50px;
					bottom:20px;
					right:68%;
				}
				img:last-child{
					width:27px; 
          left:37%;
					bottom:20px;
				}
				span{
					font-size: 20px;
					position: absolute;
					right: 10px;
		    		bottom: 28px;
		    		color:#eee;
				}
				p{
					position: absolute;
					top:21%;
					left:40%;
					color:#eee;
					img{
						width:25px!important;
						margin-right: 5px;
					}
				}
			}
			
		}
	}
	.rescue-center{  
    overflow: auto;
		position: relative;
		background: #8B97A5;
		padding:5px;
		border-left:5px solid #DDDCE2;
	}
	.rescue-center-data{
		width:100%;
		height:200px;
		background: #576371;
		margin-bottom: 10px;
		position: relative;
		>img{
			position: absolute;
		}
		img:first-child{
			width:50px;
			bottom:20px;
			right:149px;
		}
		img:last-child{
			width:30px;
			right: 104px;
			bottom:20px;
		}
		span{
			font-size: 20px;
			position: absolute;
			right: 19px;
    		bottom: 28px;
    		color:#eee;
		}
		h4{
			position: absolute;
			right:40px;
			top:31px;
			font-size: 18px;
			color:#40DC23;
		}
		div{
			position: absolute;
			left:12px;
			top:70px; 
			color:#40DC23;
			width:30%;
			p{
				margin: 0; 
				padding-left: 20%;
			}
			p:last-child{
				border-top:1px solid #40DC23;
			}
		}
		button{
			position: absolute;
			right:6px;
			top:6px;
			background: #fff;
			border:0;
			width:20px;
			height:20px; 
			line-height: 10px;
			padding:0;
			font-size: 24px;
			border-radius: 50%; 
			cursor: pointer;
			font{
				display: block;
				margin-top: -7px;
			}
		}
	}
	 .rescue{
	 	height:100%;
	 }
	 .team-info{
	 	button{
	 		background: #40DC23;
	 		color:#fff;
	 		border: 0;
	 		border-radius: 10px;
	 		padding:1px 6px;
	 		margin-top: 17px;
	 		cursor: pointer;
	 	}
	 }
</style>